import { connect } from 'react-redux'
import ErrorBoundary from './component'
import { launcherOpenUrl, attributes } from '../imports'
import { getLanguage, getSteam } from '../selectors'

function mapStateToProps(state) {
    // Try to get locale from state,
    // but since we were invoked by an error, the state might be unavailable
    let locale
    try {
        locale = getLanguage(state)
    } catch (error) {
        locale = 'en'
    }

    // Try to get locale from state,
    // but since we were invoked by an error, the state might be unavailable
    let isSteam
    try {
        isSteam = getSteam(state)
    } catch (error) {
        isSteam = false
    }

    // We currently don't have a fallback image in japanese
    if (locale === 'ja') locale = 'en'

    const origin = isSteam ? attributes.steamOrigin : attributes.defaultOrigin
    const link = attributes.fallbackLink.replace('{origin}', origin)
    const src = attributes.fallbackSource.replace('{locale}', locale)

    return {
        src,
        onClick: () => launcherOpenUrl(link),
    }
}

export default connect(mapStateToProps)(ErrorBoundary)




// WEBPACK FOOTER //
// ./src/features/Ads/error/index.js